module.exports = __webpack_public_path__ + "static/og-d3b4507a8e473095c7fbe4397e1bff0b.png";